// import React from 'react';
// import {
//   Globe,
//   Stethoscope,
//   HeartPulse,
//   Home,
//   Plane,
//   CheckCircle2,
//   ArrowRight,
//   Phone
// } from 'lucide-react';

// const services = [
//   {
//     title: "International Patient Services",
//     icon: <Globe className="w-7 h-7" />,
//     items: [
//       "Accommodation Assistance",
//       "Interpreter Services",
//       "SIM Card & Connectivity",
//       "Currency Exchange",
//       "FRRO Assistance"
//     ]
//   },
//   {
//     title: "Healthcare Facilitation",
//     icon: <Stethoscope className="w-7 h-7" />,
//     items: [
//       "Doctor Consultations",
//       "Surgery Planning",
//       "Second Opinion",
//       "Remote Consultations",
//       "Treatment Estimates"
//     ]
//   },
//   {
//     title: "Post-Treatment Support",
//     icon: <HeartPulse className="w-7 h-7" />,
//     items: [
//       "Follow-Up Monitoring",
//       "Medication Supply",
//       "Physiotherapy & Rehab",
//       "Reports & Record Sharing",
//       "Nursing Care at Hotel"
//     ]
//   },
//   {
//     title: "Domestic Patients",
//     icon: <Home className="w-7 h-7" />,
//     items: [
//       "Ambulance",
//       "Medical Travel Insurance"
//     ]
//   },
//   {
//     title: "Travel Assistance",
//     icon: <Plane className="w-7 h-7" />,
//     items: [
//       "Medical Visa",
//       "Medical Attendant Visa",
//       "Airport Transfers",
//       "Local Cabs",
//       "Air Tickets Booking"
//     ]
//   }
// ];

// const OurServices = () => {
//   return (
//     <section style={{ backgroundColor: '#fff', padding: '80px 0' }}>
//       <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 24px' }}>

//         {/* ── Header ── */}
//         <div style={{ textAlign: 'center', maxWidth: '680px', margin: '0 auto 64px' }}>
//           <span
//             style={{
//               display: 'inline-block',
//               backgroundColor: 'var(--pax-soft)',
//               color: 'var(--pax-primary)',
//               fontSize: '12px',
//               fontWeight: '700',
//               letterSpacing: '3px',
//               textTransform: 'uppercase',
//               padding: '6px 20px',
//               borderRadius: '999px',
//               marginBottom: '16px',
//               border: '1px solid var(--pax-primary)20'
//             }}
//           >
//             Our Expertise
//           </span>
//           <h2
//             style={{
//               fontSize: 'clamp(28px, 4vw, 44px)',
//               fontWeight: '800',
//               color: 'var(--pax-secondary)',
//               lineHeight: '1.2',
//               marginBottom: '16px'
//             }}
//           >
//             Comprehensive Care{' '}
//             <span style={{ color: 'var(--pax-primary)' }}>Beyond Borders</span>
//           </h2>
//           <p style={{ color: 'var(--pax-gray)', fontSize: '17px', lineHeight: '1.7' }}>
//             We provide end-to-end support for your medical journey — ensuring comfort,
//             safety, and world-class treatment at every step.
//           </p>
//         </div>

//         {/* ── Services Grid ── */}
//         <div
//           style={{
//             display: 'grid',
//             gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
//             gap: '28px',
//             alignItems: 'stretch'
//           }}
//         >
//           {services.map((service, index) => (
//             <ServiceCard key={index} service={service} />
//           ))}

//           {/* ── CTA Card ── */}
//           <div
//             style={{
//               background: 'linear-gradient(135deg, var(--pax-primary) 0%, var(--pax-dark) 100%)',
//               borderRadius: '24px',
//               padding: '40px 32px',
//               display: 'flex',
//               flexDirection: 'column',
//               justifyContent: 'center',
//               alignItems: 'center',
//               textAlign: 'center',
//               boxShadow: '0 20px 60px rgba(240,78,48,0.3)'
//             }}
//           >
//             <div
//               style={{
//                 width: '60px',
//                 height: '60px',
//                 borderRadius: '50%',
//                 backgroundColor: 'rgba(255,255,255,0.15)',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 marginBottom: '20px'
//               }}
//             >
//               <Phone style={{ color: '#fff', width: '28px', height: '28px' }} />
//             </div>
//             <h4
//               style={{
//                 color: '#fff',
//                 fontSize: '22px',
//                 fontWeight: '800',
//                 marginBottom: '12px',
//                 lineHeight: '1.3'
//               }}
//             >
//               Need a Personalized Plan?
//             </h4>
//             <p
//               style={{
//                 color: 'rgba(255,255,255,0.80)',
//                 fontSize: '15px',
//                 lineHeight: '1.7',
//                 marginBottom: '32px'
//               }}
//             >
//               Our medical coordinators are available 24/7 to assist with your specific requirements.
//             </p>
//             <a
//               href="https://wa.me/917289007800"
//               target="_blank"
//               rel="noopener noreferrer"
//               style={{
//                 backgroundColor: '#fff',
//                 color: 'var(--pax-primary)',
//                 padding: '14px 32px',
//                 borderRadius: '999px',
//                 fontWeight: '700',
//                 fontSize: '15px',
//                 textDecoration: 'none',
//                 display: 'inline-flex',
//                 alignItems: 'center',
//                 gap: '8px',
//                 transition: 'all 0.2s ease',
//                 boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
//               }}
//               onMouseEnter={e => {
//                 e.currentTarget.style.backgroundColor = 'var(--pax-soft)';
//                 e.currentTarget.style.transform = 'scale(1.04)';
//               }}
//               onMouseLeave={e => {
//                 e.currentTarget.style.backgroundColor = '#fff';
//                 e.currentTarget.style.transform = 'scale(1)';
//               }}
//             >
//               Contact Support <ArrowRight style={{ width: '16px', height: '16px' }} />
//             </a>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };


// // ── Individual Service Card ──────────────────────────────────────────────────
// const ServiceCard = ({ service }) => {
//   const [hovered, setHovered] = React.useState(false);

//   return (
//     <div
//       onMouseEnter={() => setHovered(true)}
//       onMouseLeave={() => setHovered(false)}
//       style={{
//         backgroundColor: hovered ? 'var(--pax-soft)' : '#fff',
//         border: '1px solid',
//         borderColor: hovered ? 'var(--pax-primary)' : '#f0f0f0',
//         borderRadius: '24px',
//         padding: '36px 32px',
//         boxShadow: hovered
//           ? '0 20px 50px rgba(240,78,48,0.12)'
//           : '0 2px 16px rgba(0,0,0,0.05)',
//         transform: hovered ? 'translateY(-6px)' : 'translateY(0)',
//         transition: 'all 0.3s ease',
//         cursor: 'default',
//         borderBottom: `4px solid var(--pax-primary)`,
//         position: 'relative',
//         overflow: 'hidden'
//       }}
//     >
//       {/* Decorative circle */}
//       <div
//         style={{
//           position: 'absolute',
//           top: '-30px',
//           right: '-30px',
//           width: '100px',
//           height: '100px',
//           borderRadius: '50%',
//           backgroundColor: hovered ? 'rgba(240,78,48,0.08)' : 'rgba(240,78,48,0.04)',
//           transition: 'all 0.3s ease'
//         }}
//       />

//       {/* Icon */}
//       <div
//         style={{
//           width: '60px',
//           height: '60px',
//           borderRadius: '16px',
//           backgroundColor: hovered ? 'var(--pax-primary)' : 'var(--pax-soft)',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           marginBottom: '24px',
//           color: hovered ? '#fff' : 'var(--pax-primary)',
//           transition: 'all 0.3s ease',
//           boxShadow: hovered ? '0 8px 24px rgba(240,78,48,0.3)' : 'none'
//         }}
//       >
//         {service.icon}
//       </div>

//       {/* Title */}
//       <h4
//         style={{
//           fontSize: '18px',
//           fontWeight: '700',
//           color: hovered ? 'var(--pax-primary)' : 'var(--pax-secondary)',
//           marginBottom: '20px',
//           transition: 'color 0.3s ease'
//         }}
//       >
//         {service.title}
//       </h4>

//       {/* Items */}
//       <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '12px' }}>
//         {service.items.map((item, idx) => (
//           <li key={idx} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//             <CheckCircle2
//               style={{
//                 width: '18px',
//                 height: '18px',
//                 color: 'var(--pax-primary)',
//                 flexShrink: 0
//               }}
//             />
//             <span style={{ color: 'var(--pax-gray)', fontSize: '14px', lineHeight: '1.5' }}>
//               {item}
//             </span>
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// };

// export default OurServices;



import React from 'react';
import {
  Globe,
  Stethoscope,
  HeartPulse,
  Home,
  Plane,
  CheckCircle2,
  ArrowRight,
  Phone,
  MessageCircle,
  Star,
  Award,
  Users,
  Clock
} from 'lucide-react';

const services = [
  {
    id: 1,
    title: "International Patient Services",
    subtitle: "Seamless global support",
    icon: Globe,
    gradient: "135deg, #F04E30 0%, #C73E25 100%",
    items: [
      "Accommodation Assistance",
      "Interpreter Services",
      "SIM Card & Connectivity",
      "Currency Exchange",
      "FRRO Assistance"
    ]
  },
  {
    id: 2,
    title: "Healthcare Facilitation",
    subtitle: "Expert medical coordination",
    icon: Stethoscope,
    gradient: "135deg, #FF6B4D 0%, #F04E30 100%",
    items: [
      "Doctor Consultations",
      "Surgery Planning",
      "Second Opinion",
      "Remote Consultations",
      "Treatment Estimates"
    ]
  },
  {
    id: 3,
    title: "Post-Treatment Support",
    subtitle: "Care that doesn't stop",
    icon: HeartPulse,
    gradient: "135deg, #C73E25 0%, #a33220 100%",
    items: [
      "Follow-Up Monitoring",
      "Medication Supply",
      "Physiotherapy & Rehab",
      "Reports & Record Sharing",
      "Nursing Care at Hotel"
    ]
  },
  {
    id: 4,
    title: "Domestic Patients",
    subtitle: "Local care made simple",
    icon: Home,
    gradient: "135deg, #F04E30 0%, #FF6B4D 100%",
    items: [
      "Ambulance",
      "Medical Travel Insurance"
    ]
  },
  {
    id: 5,
    title: "Travel Assistance",
    subtitle: "Stress-free medical travel",
    icon: Plane,
    gradient: "135deg, #FF6B4D 0%, #C73E25 100%",
    items: [
      "Medical Visa",
      "Medical Attendant Visa",
      "Airport Transfers",
      "Local Cabs",
      "Air Tickets Booking"
    ]
  }
];

const stats = [
  { icon: Users,  value: "5,000+", label: "Patients Served"    },
  { icon: Award,  value: "98%",    label: "Satisfaction Rate"  },
  { icon: Clock,  value: "24/7",   label: "Support Available"  },
  { icon: Star,   value: "4.9★",   label: "Average Rating"     },
];


// ── Main Component ────────────────────────────────────────────────────────────
const OurServices = () => {
  return (
    <section style={{ backgroundColor: '#fafafa', overflow: 'hidden' }}>

      {/* ── TOP ACCENT BAR ── */}
      <div style={{ height: '4px', background: 'linear-gradient(90deg, var(--pax-dark), var(--pax-primary), var(--pax-light), var(--pax-primary), var(--pax-dark))' }} />

      {/* ── HEADER ── */}
      <div style={{ backgroundColor: '#fff', padding: '80px 24px 60px', textAlign: 'center' }}>
        <div style={{ maxWidth: '720px', margin: '0 auto' }}>

          {/* eyebrow */}
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', backgroundColor: 'var(--pax-soft)', border: '1px solid rgba(240,78,48,0.2)', borderRadius: '999px', padding: '6px 20px', marginBottom: '24px' }}>
            <span style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: 'var(--pax-primary)', display: 'inline-block', animation: 'pulse 2s infinite' }} />
            <span style={{ color: 'var(--pax-primary)', fontSize: '11px', fontWeight: '800', letterSpacing: '3px', textTransform: 'uppercase' }}>
              End-to-End Care
            </span>
          </div>

          <h2 style={{ fontSize: 'clamp(32px, 5vw, 52px)', fontWeight: '900', color: 'var(--pax-secondary)', lineHeight: '1.15', marginBottom: '20px', letterSpacing: '-1px' }}>
            Every Service You Need,{' '}
            <span style={{
              color: 'var(--pax-primary)',
              position: 'relative',
              display: 'inline-block'
            }}>
              Under One Roof
            </span>
          </h2>

          <p style={{ color: 'var(--pax-gray)', fontSize: '18px', lineHeight: '1.8', maxWidth: '580px', margin: '0 auto' }}>
            From the moment you contact us to your full recovery — we handle everything
            so you can focus entirely on healing.
          </p>
        </div>
      </div>

      {/* ── STATS BAR ── */}
      <div style={{
        background: 'linear-gradient(135deg, var(--pax-primary) 0%, var(--pax-dark) 100%)',
        padding: '0 24px'
      }}>
        <div style={{
          maxWidth: '1100px',
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
        }}>
          {stats.map((stat, i) => (
            <StatItem key={i} stat={stat} isLast={i === stats.length - 1} />
          ))}
        </div>
      </div>

      {/* ── SERVICES GRID ── */}
      <div style={{ padding: '80px 24px', maxWidth: '1200px', margin: '0 auto' }}>

        {/* Section label */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '48px' }}>
          <div style={{ flex: 1, height: '1px', backgroundColor: '#e5e7eb' }} />
          <span style={{ color: 'var(--pax-gray)', fontSize: '12px', fontWeight: '700', letterSpacing: '2px', textTransform: 'uppercase', whiteSpace: 'nowrap' }}>
            Our Services
          </span>
          <div style={{ flex: 1, height: '1px', backgroundColor: '#e5e7eb' }} />
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
          gap: '24px',
          alignItems: 'start'
        }}>
          {services.map((service, index) => (
            <ServiceCard key={service.id} service={service} index={index} />
          ))}

          {/* CTA CARD */}
          <CTACard />
        </div>
      </div>

      {/* ── BOTTOM TRUST STRIP ── */}
      <div style={{ backgroundColor: '#fff', borderTop: '1px solid #f0f0f0', padding: '32px 24px' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto', display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center', gap: '32px' }}>
          {['ISO Certified', 'NABH Affiliated', 'JCI Accredited Hospitals', 'Secure & Confidential', '10+ Years Experience'].map((badge, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <CheckCircle2 style={{ width: '16px', height: '16px', color: 'var(--pax-primary)' }} />
              <span style={{ color: 'var(--pax-secondary)', fontSize: '13px', fontWeight: '600' }}>{badge}</span>
            </div>
          ))}
        </div>
      </div>

    </section>
  );
};


// ── Stat Item ─────────────────────────────────────────────────────────────────
const StatItem = ({ stat, isLast }) => {
  const [hovered, setHovered] = React.useState(false);
  const Icon = stat.icon;

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        padding: '28px 24px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '6px',
        borderRight: isLast ? 'none' : '1px solid rgba(255,255,255,0.15)',
        backgroundColor: hovered ? 'rgba(255,255,255,0.08)' : 'transparent',
        transition: 'background 0.3s ease',
        cursor: 'default'
      }}
    >
      <Icon style={{ width: '22px', height: '22px', color: 'rgba(255,255,255,0.7)', marginBottom: '4px' }} />
      <span style={{ color: '#fff', fontSize: '28px', fontWeight: '900', letterSpacing: '-1px' }}>
        {stat.value}
      </span>
      <span style={{ color: 'rgba(255,255,255,0.7)', fontSize: '12px', fontWeight: '600', letterSpacing: '1px', textTransform: 'uppercase' }}>
        {stat.label}
      </span>
    </div>
  );
};


// ── Service Card ──────────────────────────────────────────────────────────────
const ServiceCard = ({ service, index }) => {
  const [hovered, setHovered] = React.useState(false);
  const Icon = service.icon;

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        backgroundColor: '#fff',
        borderRadius: '20px',
        overflow: 'hidden',
        boxShadow: hovered
          ? '0 24px 64px rgba(240,78,48,0.14), 0 4px 16px rgba(0,0,0,0.06)'
          : '0 2px 20px rgba(0,0,0,0.06)',
        transform: hovered ? 'translateY(-8px)' : 'translateY(0)',
        transition: 'all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1)',
        cursor: 'default',
        border: `1px solid ${hovered ? 'rgba(240,78,48,0.2)' : '#f0f0f0'}`,
        position: 'relative'
      }}
    >
      {/* Card Top Colored Band */}
      <div style={{
        background: `linear-gradient(${service.gradient})`,
        padding: '28px 28px 24px',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* Decorative Circles */}
        <div style={{ position: 'absolute', top: '-20px', right: '-20px', width: '120px', height: '120px', borderRadius: '50%', backgroundColor: 'rgba(255,255,255,0.1)' }} />
        <div style={{ position: 'absolute', bottom: '-30px', right: '30px', width: '80px', height: '80px', borderRadius: '50%', backgroundColor: 'rgba(255,255,255,0.08)' }} />

        {/* Index Number */}
        <div style={{
          position: 'absolute',
          top: '20px',
          right: '24px',
          fontSize: '48px',
          fontWeight: '900',
          color: 'rgba(255,255,255,0.15)',
          lineHeight: 1,
          letterSpacing: '-2px'
        }}>
          0{index + 1}
        </div>

        {/* Icon */}
        <div style={{
          width: '52px',
          height: '52px',
          borderRadius: '14px',
          backgroundColor: 'rgba(255,255,255,0.2)',
          backdropFilter: 'blur(8px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '14px',
          border: '1px solid rgba(255,255,255,0.3)'
        }}>
          <Icon style={{ width: '24px', height: '24px', color: '#fff' }} />
        </div>

        <h4 style={{ color: '#fff', fontSize: '18px', fontWeight: '800', marginBottom: '4px', lineHeight: '1.3' }}>
          {service.title}
        </h4>
        <p style={{ color: 'rgba(255,255,255,0.75)', fontSize: '13px', fontWeight: '500' }}>
          {service.subtitle}
        </p>
      </div>

      {/* Card Body */}
      <div style={{ padding: '24px 28px 28px' }}>
        <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {service.items.map((item, idx) => (
            <li
              key={idx}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                padding: '8px 12px',
                borderRadius: '10px',
                backgroundColor: hovered ? 'var(--pax-soft)' : '#fafafa',
                transition: 'background-color 0.3s ease',
              }}
            >
              <div style={{
                width: '20px',
                height: '20px',
                borderRadius: '50%',
                backgroundColor: hovered ? 'var(--pax-primary)' : 'rgba(240,78,48,0.1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                transition: 'all 0.3s ease'
              }}>
                <CheckCircle2 style={{ width: '12px', height: '12px', color: hovered ? '#fff' : 'var(--pax-primary)' }} />
              </div>
              <span style={{ color: 'var(--pax-secondary)', fontSize: '13.5px', fontWeight: '500', lineHeight: '1.4' }}>
                {item}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};


// ── CTA Card ─────────────────────────────────────────────────────────────────
const CTACard = () => {
  const [btnHovered, setBtnHovered] = React.useState(false);
  const [waHovered, setWaHovered] = React.useState(false);

  return (
    <div style={{
      background: 'linear-gradient(145deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
      borderRadius: '20px',
      padding: '40px 32px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      position: 'relative',
      overflow: 'hidden',
      boxShadow: '0 24px 64px rgba(0,0,0,0.2)',
      border: '1px solid rgba(255,255,255,0.05)'
    }}>
      {/* Glow blobs */}
      <div style={{ position: 'absolute', top: '-40px', left: '-40px', width: '160px', height: '160px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(240,78,48,0.3) 0%, transparent 70%)', filter: 'blur(20px)' }} />
      <div style={{ position: 'absolute', bottom: '-40px', right: '-40px', width: '160px', height: '160px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(240,78,48,0.2) 0%, transparent 70%)', filter: 'blur(20px)' }} />

      {/* Badge */}
      <div style={{ backgroundColor: 'rgba(240,78,48,0.15)', border: '1px solid rgba(240,78,48,0.3)', borderRadius: '999px', padding: '5px 16px', marginBottom: '24px', zIndex: 1 }}>
        <span style={{ color: 'var(--pax-light)', fontSize: '11px', fontWeight: '700', letterSpacing: '2px', textTransform: 'uppercase' }}>
          Available 24 / 7
        </span>
      </div>

      {/* Icon */}
      <div style={{
        width: '72px',
        height: '72px',
        borderRadius: '20px',
        background: 'linear-gradient(135deg, var(--pax-primary), var(--pax-dark))',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '24px',
        boxShadow: '0 12px 32px rgba(240,78,48,0.4)',
        zIndex: 1
      }}>
        <Phone style={{ color: '#fff', width: '32px', height: '32px' }} />
      </div>

      <h4 style={{ color: '#fff', fontSize: '24px', fontWeight: '900', marginBottom: '14px', lineHeight: '1.3', zIndex: 1 }}>
        Need a Personalized <span style={{ color: 'var(--pax-light)' }}>Care Plan?</span>
      </h4>

      <p style={{ color: 'rgba(255,255,255,0.60)', fontSize: '14px', lineHeight: '1.8', marginBottom: '32px', zIndex: 1 }}>
        Our dedicated medical coordinators are standing by to build a customized plan
        tailored to your needs.
      </p>

      {/* Buttons */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', width: '100%', zIndex: 1 }}>
        <a
          href="tel:+917289007800"
          onMouseEnter={() => setBtnHovered(true)}
          onMouseLeave={() => setBtnHovered(false)}
          style={{
            background: btnHovered
              ? 'linear-gradient(135deg, var(--pax-light), var(--pax-primary))'
              : 'linear-gradient(135deg, var(--pax-primary), var(--pax-dark))',
            color: '#fff',
            padding: '14px 24px',
            borderRadius: '14px',
            fontWeight: '700',
            fontSize: '14px',
            textDecoration: 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            transition: 'all 0.3s ease',
            boxShadow: btnHovered ? '0 8px 24px rgba(240,78,48,0.5)' : '0 4px 16px rgba(240,78,48,0.3)',
            transform: btnHovered ? 'scale(1.02)' : 'scale(1)'
          }}
        >
          <Phone style={{ width: '16px', height: '16px' }} />
          Call Us Now
          <ArrowRight style={{ width: '15px', height: '15px' }} />
        </a>

        <a
          href="https://wa.me/917289007800"
          target="_blank"
          rel="noopener noreferrer"
          onMouseEnter={() => setWaHovered(true)}
          onMouseLeave={() => setWaHovered(false)}
          style={{
            backgroundColor: waHovered ? 'rgba(255,255,255,0.12)' : 'rgba(255,255,255,0.06)',
            color: '#fff',
            padding: '14px 24px',
            borderRadius: '14px',
            fontWeight: '700',
            fontSize: '14px',
            textDecoration: 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            transition: 'all 0.3s ease',
            border: '1px solid rgba(255,255,255,0.12)',
            transform: waHovered ? 'scale(1.02)' : 'scale(1)'
          }}
        >
          <MessageCircle style={{ width: '16px', height: '16px', color: '#25d366' }} />
          WhatsApp Us
        </a>
      </div>
    </div>
  );
};

export default OurServices;
